module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.b06871f2.b06871f2.ttf";